<template>
  <div>
    <Tabs>
      <TabPane label="动态发布">
        <NewsRelease></NewsRelease>
      </TabPane>
      <TabPane label="预警精灵">
        <WarningSpirit></WarningSpirit>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import NewsRelease from "@/views/newsRelease/components/NewsRelease/newsRelease.vue";
import WarningSpirit from "@/views/newsRelease/components/WarningSpirit/WarningSpirit.vue";

export default {
  components: {
    NewsRelease,
    WarningSpirit
  },
  data() {
    return {}
  }
}
</script>
